import type { ReactNode } from 'react';

export const symbol_pace: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q84 0 156.5 31.5T763-763q54 54 85.5 126.5T880-480q0 17-1 34t-4 34q-2 12-13 19t-23 4q-12-3-18.5-14t-4.5-24q2-13 3-26t1-27q0-71-26-133t-73-108q-46-47-108-73t-133-26q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140q49 0 93.5-13.5T657-190q11-7 23-4.5t20 12.5q8 10 5.5 22T692-141q-47 29-100 45T480-80Zm271.5-172.5Q740-264 740-281t11.5-28.5Q763-321 780-321t28.5 11.5Q820-298 820-281t-11.5 28.5Q797-241 780-241t-28.5-11.5ZM513-492l137 138q9 9 9 22t-9 22q-10 10-23 10t-22-10L461-459q-4-5-6-10t-2-11v-183q0-13 8.5-21.5T483-693q13 0 21.5 8.5T513-663v171Z"
		/>
	</svg>
);
